import _objectSpread from "/data/jenkins/workspaces/workspace/h5/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.string.search.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapGetters } from 'vuex';
import vueQr from 'vue-qr';
import cache from '@/utils/cache';
import { login } from '@/api/accountLogin';
import { rsa, parseUrl } from '@/utils/tools';
import qrMinxin from './qr_mixin';
export default {
  components: {
    vueQr: vueQr
  },
  mixins: [qrMinxin],
  data: function data() {
    var _this = this;

    var validateName = function validateName(rule, value, callback) {
      if (value === '') {
        _this.nameFlag = false;
        _this.userError = false;
        callback();
      } else {
        _this.nameFlag = true;
        callback();
      }
    };

    var validatePsw = function validatePsw(rule, value, callback) {
      if (value === '') {
        _this.pswFlag = false;
        _this.passwError = false;
        callback();
      } else {
        _this.pswFlag = true;
        callback();
      }
    };

    return {
      loginForm: {
        username: '',
        pasw: ''
      },
      paswshow: 'password',
      loginRules: {
        username: [{
          validator: validateName,
          trigger: 'change'
        }],
        pasw: [{
          validator: validatePsw,
          trigger: 'change'
        }]
      },
      // 表单是否符合标识
      nameFlag: false,
      pswFlag: false,
      domains: [],
      wudomain: '',
      reqFlag: 0,
      url: '',
      reqUrlPath: '',
      jumpUrl: '',
      domLoad: false,
      loginText: '登录',
      userClose: false,
      passClose: false,
      userError: false,
      passwError: false,
      userErrorText: '',
      paswErrorText: '',
      doubleVerifyTip: '为加强登录安全防护，2023年1月起密码登录将增加短信或人脸识别认证'
    };
  },
  computed: _objectSpread(_objectSpread({}, mapGetters(['appConfig'])), {}, {
    confirmDisabled: function confirmDisabled() {
      return !(this.nameFlag && this.pswFlag);
    }
  }),
  watch: {
    'loginForm.username': function loginFormUsername(val) {
      this.loginForm.username = this.loginForm.username.replace(/\s+/g, '');
    },
    'loginForm.pasw': function loginFormPasw(val) {
      this.loginForm.pasw = this.$utils.passwordRegexp(val);
    }
  },
  mounted: function mounted() {
    navigator.userAgent.indexOf('WebKit') > -1 && this.webkitBrowserInit(); // 默认二维码登录时，手动刷下QR

    this.isQrLogin && this.refreshQr();
    this.$utils.zhugeTrack('web-访问-登录页-PV');
  },
  methods: {
    /**
     * @func Chrome浏览器初始化
     * @desc 解决Chrome下触发自动填充时输入框难看的黄色背景
     */
    webkitBrowserInit: function webkitBrowserInit() {
      var _this2 = this;

      this.$nextTick(function () {
        setTimeout(function () {
          if (document.querySelector(':-webkit-autofill')) {
            _this2.nameFlag = true;
            _this2.pswFlag = true;
          }
        }, 1000);
      });
    },

    /**
     * @func 用户点击登录，或者敲击enter键
     */
    confirm: function confirm() {
      var _this3 = this;

      // 禁止提交时，敲击enter，取消响应
      if (this.confirmDisabled) return; // 离线，提交不可用

      if (!navigator.onLine) {
        return this.$message.warning('当前网络不可用，请检查网络设置');
      } // 重置状态--防止二维码扫描污染数据


      this.reset(); // 执行登录

      this.loginText = '登录中...';
      var _this$loginForm = this.loginForm,
          username = _this$loginForm.username,
          pasw = _this$loginForm.pasw;

      var _parseUrl = parseUrl(window.location.href),
          sysCode = _parseUrl.sysCode;

      login({
        userName: username,
        password: rsa(pasw),
        service: this.service || '',
        sysCode: sysCode || '',
        forYts: this.isYTS
      }, this.service || '').then(function (res) {
        var _ref = res || {},
            code = _ref.code,
            data = _ref.data,
            url = _ref.url,
            message = _ref.message;

        if (code === '1') {
          // 登录成功
          _this3.handleLoginSuccess(data, url);
        } else if (code === '3011') {
          // 补充手机号
          _this3.bindPhone(data.userName);
        } else if (code === '5201' || code === '5202') {
          // 触发强改密
          _this3.forceModifyPassword(data, code);
        } else if (code === '3012' || code === '3013' || code === '3014') {
          // 账号探活
          _this3.oaProbe(data, code, url);
        } else if (code === '5204') {
          // 二次认证
          _this3.doubleVerify(data, message, 'passwordLogin');
        } else {
          _this3.handleLoginError(code, data, message);
        }

        _this3.loginText = '登录';
      }).catch(function (err) {
        console.log('登录页-登录失败：', err);
        _this3.loginText = '登录';

        _this3.$utils.loginZhuge('web-点击-登录页-登录失败', '密码登录');
      });
    },

    /**
     * @func 账号密码登录成功后续逻辑
     */
    handleLoginSuccess: function handleLoginSuccess(data, url) {
      data.domains && (this.domains = decodeURIComponent(data.domains).split(','));
      this.wudomain = data.wudomain;
      this.url = url;
      cache.set('LOGININFO', data); // 对所有龙湖白名单域名种cookie，并前往服务页面地址

      this.buryCookiesAndToClient(this.domains, this.wudomain, this.url); // 埋点及APM初始化

      this.initZhugeAndApm(this.loginForm.username);
      this.$utils.loginZhuge('web-点击-登录页-登录成功', '密码登录');
    },

    /**
     * @func 登录页面的错误处理
     * @param code 错误码
     * @param message 错误信息
     */
    handleLoginError: function handleLoginError(code, data, message) {
      if (code === '3003' || code === '3004' || code === '3005' || code === '3006') {
        this.userError = true;
        this.userErrorText = message;
        this.$utils.loginZhuge('web-点击-登录页-登录失败', '密码登录');
      } else if (code === '3000' || code === '3001' || code === '3002') {
        this.passwError = true;
        this.paswErrorText = message;
        this.$utils.loginZhuge('web-点击-登录页-登录失败', '密码登录');
      } else {
        this.$message.error(message);
        this.$utils.loginZhuge('web-点击-登录页-登录失败', '密码登录');
      }
    },

    /**
     * @func 切换短信登录
     */
    changeType: function changeType() {
      this.$store.commit('login/SET_LOGINTYPE', 'phone');
      this.$store.commit('login/SET_QRLOGIN', false);
    },

    /**
     * @func 切换二维码登录
     * @desc 如果是二维码登录，需要刷新二维码图片
     */
    loginTypeToggle: function loginTypeToggle() {
      // 更新是否为二维码登录状态
      this.$store.commit('login/SET_QRLOGIN', !this.isQrLogin); // 如果二维码处在失效状态，刷新二维码

      if (this.isQrLogin) {
        if (this.qrCodeExpired) {
          this.refreshQr();
        } else {
          // 传autoRefreash解决在进入短信登录页时未失效，切回二维码登录时二维码已经失效，需要自动刷新
          this.checkQrResult({
            autoRefreash: true
          });
        }
      }
    },

    /**
     * @func 用户聚焦密码框，执行输入
     */
    paswFocus: function paswFocus(e) {
      this.passwError = false;
      var obj = e.srcElement;
      obj.focus();
      var len = obj.value.length;
      obj.style.caretColor = 'transparent';
      setTimeout(function () {
        obj.style.caretColor = 'black';
        obj.selectionStart = obj.selectionEnd = len;
      }, 60);
    },
    showPass: function showPass() {
      this.paswshow = this.paswshow === 'text' ? 'password' : 'text';
      this.$refs.paswInput.focus();
    },

    /**
     * @func 忘记密码
     */
    forgetPsw: function forgetPsw() {
      this.$utils.zhugeTrack('web-点击-登录页-找回密码', {
        'OA账号': this.loginForm.username || '',
        '来源系统': 'IDM'
      });
      var url = window.location.search || '';
      this.$router.push("/login/retrievePsw".concat(url));
    },

    /**
     * @func 触发强改密
     * @param {Object} data 登录接口请求返回的数据
     * @desc 5201-首登强改密、5202-弱密改密
     */
    forceModifyPassword: function forceModifyPassword(data, code) {
      var modifyUserInfo = data;
      modifyUserInfo.flag = code === '5202' ? '2' : '1';
      cache.set('modifyUserInfo', modifyUserInfo);
      this.$router.push({
        path: '/login/modifyPassword'
      });
    }
  }
};